module.exports = __webpack_public_path__ + "static/media/user-dashboard-client-profile-with-no-photo.ff3919b1.svg";